<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'stamp']" />
        <span class="title">Object classification</span>
      </Header>
      <v-row class="tabel">
        <v-col>
          <thead>
            <tr>
              <th class="text-left" width="5%">Icon</th>
              <th class="text-left" width="15%">Object</th>
              <th class="text-left" width="15%">Number objects</th>
              <th class="text-left" width="15%">Confidence level</th>
              <th class="text-left" width="15%">
                Number objects >= confidence
              </th>
              <th class="text-left" width="15%">Test</th>
              <th class="text-left" width="10%">Assign</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in classes" :key="item.name">
              <td>
                <font-awesome-icon :icon="item.icon" size="2x" />
              </td>
              <td>{{ item.label }}</td>
              <td>{{ item.n }}</td>
              <td>
                <v-text-field
                  v-model="item.class_confidence"
                  value="item.class_confidence"
                  class="hide_arrow"
                  dense
                  type="number"
                  background-color="#42B98340"
                  min="0"
                  @change="change(item)"
                >
                </v-text-field>
              </td>

              <td>{{ item.nconf }}</td>
              <td>
                <router-link
                  :to="{
                    name: 'settings_class_test',
                    params: { id: item.class_id }
                  }"
                  ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                    size="4x"
                    > Do test</span
                  ></router-link
                >
              </td>
              <td>
                <v-switch
                  v-model="item.assign"
                  color="#00ff00"
                  false-value="0"
                  true-value="1"
                  hide-details
                  @change="change(item)"
                ></v-switch>
              </td>
            </tr>
          </tbody>
        </v-col>
      </v-row>
      <v-btn @click="update_mainclass()">Accept assign Main class</v-btn>
    </v-container>
  </v-app>
</template>
<script>
import Header from "@/components/Header.vue";
import ProjectService from "@/services/ProjectService.js";
export default {
  data() {
    return {
      classes: {},
      height: 840
    };
  },
  components: {
    Header
  },
  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "settings_class"
    })
      .then(response => {
        console.log(response.data);
        this.classes = response.data.classes;
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
  },
  methods: {
    update_mainclass() {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_main_class_update"
      });
      this.getList();
    },
    change(test) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_class_update",
        vars: test
      })
        .then(response => {
          console.log(response.data);
          this.classes[test.class_id].nconf = response.data;
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    }
  }
};
</script>
<style scoped>
.tabel .hide_arrow {
  width: 50px;
}
.tabel .col,
.tabel .col-4 {
  padding: 4px;
}
.tabel td {
  height: 28px;
}

tr.tabelr {
  height: 30px;
}
</style>
